import { render } from "./TicketsListTitle.vue?vue&type=template&id=aea11864"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "aea11864"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aea11864', script)) {
    api.reload('aea11864', script)
  }
  
  module.hot.accept("./TicketsListTitle.vue?vue&type=template&id=aea11864", () => {
    api.rerender('aea11864', render)
  })

}

script.__file = "src/views/support/pageTitles/TicketsListTitle.vue"

export default script